'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var dayView = require('./day-view-2d405f72.js');
var daysView_styles = require('./days-view.styles-ea58f0e4.js');

var DaysView = function (_a) {
    var data = _a.data, handleClick = _a.onClick, size = _a.size, variant = _a.variant;
    return (React__default.createElement(daysView_styles.DayViewWrapper, { className: "days-view", variant: variant }, data.map(function (day, index) { return (React__default.createElement(dayView.DayView, { data: day, index: index, onClick: handleClick, size: size, key: day.month && day.date && day.year ? day.month + "-" + day.date + "-" + day.year : index })); })));
};

exports.DaysView = DaysView;
